import { useCallback, useEffect, useState } from 'react';
import { getProjects, createProject, updateProject, deleteProject } from '../services/projectsService';

export function useProjects() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const refetch = useCallback(() => {
    setLoading(true);
    return getProjects()
      .then((data) => {
        setProjects(data);
        setError('');
      })
      .catch((err) => setError(err.message || 'Failed to load projects'))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  const create = useCallback(
    async (projectData) => {
      await createProject(projectData);
      await refetch();
    },
    [refetch]
  );

  const update = useCallback(
    async (id, projectData, previousData) => {
      await updateProject(id, projectData, previousData);
      await refetch();
    },
    [refetch]
  );

  const remove = useCallback(
    async (id, record) => {
      await deleteProject(id, record);
      await refetch();
    },
    [refetch]
  );

  return { projects, loading, error, create, update, remove };
}
